import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
// import { Redirect } from 'react-router-dom';
import { Spin } from 'antd';
import { verifiedAuth } from 'app/features/auth/slice';
import { AuthContext } from 'app/providers/Authentication';
import { Navigate } from 'react-router';

export default function VerifyAuth() {
  const { isAuthorized } = useContext(AuthContext);
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(window.location.search);
  const state = searchParams.get('state');

  if (state) {
    const config = JSON.parse(window.atob(state));
    if (config.token) {
      dispatch(
        verifiedAuth({
          ...config
        })
      );
    }
  }
  if (isAuthorized) {
    return <Navigate to="/dashboard" />;
  }
  return (
    <div
      style={{
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Spin spinning />
    </div>
  );
}
